/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostadminsyncproviderPostAdminSyncProviderResponse
 */
export interface JumboPostadminsyncproviderPostAdminSyncProviderResponse {
    /**
     * 
     * @type {string}
     * @memberof JumboPostadminsyncproviderPostAdminSyncProviderResponse
     */
    runID?: string;
}

/**
 * Check if a given object implements the JumboPostadminsyncproviderPostAdminSyncProviderResponse interface.
 */
export function instanceOfJumboPostadminsyncproviderPostAdminSyncProviderResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostadminsyncproviderPostAdminSyncProviderResponseFromJSON(json: any): JumboPostadminsyncproviderPostAdminSyncProviderResponse {
    return JumboPostadminsyncproviderPostAdminSyncProviderResponseFromJSONTyped(json, false);
}

export function JumboPostadminsyncproviderPostAdminSyncProviderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostadminsyncproviderPostAdminSyncProviderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'runID': !exists(json, 'runID') ? undefined : json['runID'],
    };
}

export function JumboPostadminsyncproviderPostAdminSyncProviderResponseToJSON(value?: JumboPostadminsyncproviderPostAdminSyncProviderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'runID': value.runID,
    };
}

